import aws from "../../../../assets/images/technology_partners_images/aws.png";
import csharp from "../../../../assets/images/technology_partners_images/c#.png";
import docker from "../../../../assets/images/technology_partners_images/docker.png";
import figma from "../../../../assets/images/technology_partners_images/figma.png";
import firebase from "../../../../assets/images/technology_partners_images/firebase.png";
import flutter from "../../../../assets/images/technology_partners_images/flutter.png";
import gemini from "../../../../assets/images/technology_partners_images/gemini.png";
import git from "../../../../assets/images/technology_partners_images/git.png";
import github from "../../../../assets/images/technology_partners_images/github.png";
import gitlab from "../../../../assets/images/technology_partners_images/gitlab.png";
import google_cloud from "../../../../assets/images/technology_partners_images/google_cloud.png";
import gpt from "../../../../assets/images/technology_partners_images/gpt.png";
import jira from "../../../../assets/images/technology_partners_images/jira.png";
import js from "../../../../assets/images/technology_partners_images/js.png";
import linguagem_r from "../../../../assets/images/technology_partners_images/linguagem_r.png";
import mongo from "../../../../assets/images/technology_partners_images/mongo.png";
import node from "../../../../assets/images/technology_partners_images/node.png";
import power_bi from "../../../../assets/images/technology_partners_images/power_bi.png";
import pyton from "../../../../assets/images/technology_partners_images/pyton.png";
import react from "../../../../assets/images/technology_partners_images/react.png";
import sql_server from "../../../../assets/images/technology_partners_images/sql_server.png";
import tableau from "../../../../assets/images/technology_partners_images/tableau.png";
import visual_studio from "../../../../assets/images/technology_partners_images/visual_studio.png";
import oniumLogo from "../../../../assets/images/partnerships/onium.png";
import pavioLogo from "../../../../assets/images/partnerships/pavio.png";
import melissaturLogo from "../../../../assets/images/partnerships/melissatur.png";
import pazzeLogo from "../../../../assets/images/partnerships/pazze.png";

export const technologyPartnersMapper = {
    titles: {
        technologies: "Tecnologias",
        partnerships: "Parcerias",
    },
    imagesTechnologies: [
        aws, csharp, docker, figma, firebase, flutter, gemini, git, github, gitlab,
        google_cloud, gpt, jira, js, linguagem_r, mongo, node, power_bi, pyton,
        react, sql_server, tableau, visual_studio,
    ],
    partnersCarousel: [
        { image: oniumLogo },
        { image: pavioLogo },
        { image: melissaturLogo },
        { image: pazzeLogo },
    ],
    partnershipSliderConfig: {
        loop: true,
        renderMode: "performance",
        drag: true,
        slides: { perView: 3, spacing: 120 },
        breakpoints: {
            "(max-width: 1530px)": { slides: { perView: 2, spacing: 100 } },
            "(max-width: 1021px)": { slides: { perView: 1, spacing: 48 } },
            "(max-width: 768px)": { slides: { perView: 1, spacing: 48 } },
            "(max-width: 480px)": { slides: { perView: 1, spacing: 48 } },
        },
    },
    sliderConfig: {
        loop: true,
        renderMode: "performance",
        drag: false,
        slides: { perView: 4, spacing: 100 },
        breakpoints: {
            "(max-width: 1290px)": { slides: { perView: 3, spacing: 100 } },
            "(max-width: 1024px)": { slides: { perView: 2.7, spacing: 150 } },
            "(max-width: 768px)": { slides: { perView: 2, spacing: 100 } },
            "(max-width: 480px)": { slides: { perView: 2, spacing: 70 } },
            "(max-width: 320px)": { slides: { perView: 1.2, spacing: 0 } },
        },
    },
    animation: { duration: 9000, easing: (t) => t },
};
